import type { StructuredContentDocument } from '@repo/supergraph-schemas/structuredContent/types';

export type AnchorLinkTargetProps = StructuredContentDocument<{
  target: string;
}>;

export const AnchorLinkTarget = ({ props: { target } }: AnchorLinkTargetProps) => {
  return <span id={target} />;
};
